import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import React from 'react';
import classNames from 'classnames';
import renderTextFromDataSource from '../utils/renderTextFromDataSource.js';
import './index.less.js';

function TiDescriptions(props) {
  var style = props.style,
    _a = props.border,
    border = _a === void 0 ? false : _a,
    _b = props.direction,
    direction = _b === void 0 ? 'horizontal' : _b,
    _c = props.align,
    align = _c === void 0 ? 'left' : _c,
    _d = props.columns,
    columns = _d === void 0 ? [] : _d,
    _e = props.dataSource,
    dataSource = _e === void 0 ? {} : _e;
  return /*#__PURE__*/React.createElement("div", {
    className: "ti-descriptions",
    style: style
  }, columns.map(function (x, i) {
    var _a, _b, _c, _d;
    var dataIndex = x.dataIndex,
      title = x.title,
      valueEnum = x.valueEnum,
      render = x.render,
      _e = x.hideInDescriptions,
      hideInDescriptions = _e === void 0 ? false : _e,
      _f = x.border,
      _border = _f === void 0 ? border : _f,
      _g = x.direction,
      _direction = _g === void 0 ? direction : _g,
      _h = x.align,
      _align = _h === void 0 ? align : _h;
    if (hideInDescriptions) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: i
      });
    }
    var value = renderTextFromDataSource({
      dataIndex: dataIndex,
      valueEnum: valueEnum,
      render: render
    }, dataSource);
    var descriptionCls = classNames((_a = {}, _a['ti-description'] = true, _a));
    var contentCls = classNames((_b = {}, _b['ti-description-content'] = true, _b['ti-description-horizontal'] = _direction === 'horizontal', _b['ti-description-vertical'] = _direction === 'vertical', _b['ti-description-border'] = _border, _b));
    var labelCls = classNames((_c = {}, _c['ti-description-label'] = true, _c['ti-description-label-width'] = _direction === 'horizontal' && _align === 'left', _c));
    var valueCls = classNames((_d = {}, _d['ti-description-value'] = true, _d['ti-description-value-left'] = _align === 'left', _d['ti-description-value-right'] = _align === 'right', _d['ti-description-value-center'] = _align === 'center', _d));
    return /*#__PURE__*/React.createElement("div", {
      className: descriptionCls,
      key: i
    }, /*#__PURE__*/React.createElement("div", {
      className: contentCls
    }, /*#__PURE__*/React.createElement("div", {
      className: labelCls
    }, title), /*#__PURE__*/React.createElement("div", {
      className: valueCls
    }, value)));
  }));
}

export { TiDescriptions as default };
